import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAppContextState, appContextKey } from '@app/core/store/app-context/app-context.state';
import { IBuildInfo } from '@app/api/interfaces/build-info';

export const selectBuildInfoState = createFeatureSelector<IAppContextState>(appContextKey);

export const selectBuildInfoLoading = createSelector(selectBuildInfoState, (state): boolean => state.buildInfo.loading);

export const selectBuildInfoLoaded = createSelector(selectBuildInfoState, (state): boolean => state.buildInfo.loaded);

export const selectBuildInfo = createSelector(selectBuildInfoState, (state): IBuildInfo | null => state.buildInfo.data);

export const selectIsBuildInfoError = createSelector(
  selectBuildInfoState,
  (state): boolean => state.buildInfo.data === null && state.buildInfo.loaded
);
